import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalysisApiClientAccess, AppService } from '@nk/access-block';
import { CachingService } from '@nk/caching-lib';
import { AppFeatureKey, AppRoleKey, CollectionCaseCompositeEntity, COUNTRY_FEATURES } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CollectionCaseService {
  // TODO: Rename to PaymentRemarkService
  constructor(
    private _analysisApiAccess: AnalysisApiClientAccess,
    private _cachingService: CachingService,
    private _appService: AppService,
  ) {}

  public collectionCaseCompositeEntityListCache = this._cachingService.create(
    this,
    this.collectionCaseCompositeEntityList,
  );
  public collectionCaseCompositeEntityList(payload: {
    debtorCompanyIdentifier?: string;
    debtorWatchlistUuid?: string;
    collectionAgencyIdentifier?: string;
    collectionCaseIdentifier?: string;
    creditorCompanyIdentifier?: string;
  }): Observable<CollectionCaseCompositeEntity[]> {
    return this._appService.identityDataCache.get().pipe(
      switchMap((identity) => {
        let params = new HttpParams();
        const {
          debtorCompanyIdentifier,
          debtorWatchlistUuid,
          collectionAgencyIdentifier,
          collectionCaseIdentifier,
          creditorCompanyIdentifier,
        } = payload;
        if (debtorCompanyIdentifier) {
          params = params.append('debtor_company_identifier', debtorCompanyIdentifier);
        }
        if (debtorWatchlistUuid) {
          params = params.append('debtor_watchlist_uuid', debtorWatchlistUuid);
        }
        if (collectionAgencyIdentifier) {
          params = params.append('collection_agency_identifier', collectionAgencyIdentifier);
        }
        if (collectionCaseIdentifier) {
          params = params.append('collection_case_identifier', collectionCaseIdentifier);
        }
        if (creditorCompanyIdentifier) {
          params = params.append('creditor_company_identifier', creditorCompanyIdentifier);
        }
        params = params.append('app_customer_uuid', identity.app_customer.uuid);
        params = params.append('app_membership_uuid', identity.app_membership.uuid);

        return this._analysisApiAccess
          .get<
            CollectionCaseCompositeEntity[]
          >(`/collection-case-composite`, { params }, [AppFeatureKey.base, AppFeatureKey.payment_remark, AppFeatureKey.payment_remark_company_overview, ...COUNTRY_FEATURES], [AppRoleKey.credit_check])
          .pipe(
            map((items) =>
              items.sort(
                (a, b) =>
                  b.collection_case.collection_reg_date.getTime() - a.collection_case.collection_reg_date.getTime(),
              ),
            ),
          );
      }),
    );
  }
}
